var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBellLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 604 431",
    style: {
      enableBackground: "new 0 0 604 431"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#85E6C4;}\n\t.st1{fill:#6D44E5;}\n\t.st2{fill:#517CE3;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.7,166.2h363.2l-40.8,74.4c-8.5,15.6-24.9,25.2-42.6,25.2H19.1L73.7,166.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M221.8,314.4H585l-40.8,74.4c-8.5,15.6-24.9,25.2-42.6,25.2H167.2L221.8,314.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M221.8,18H585l-40.8,74.4c-8.5,15.6-24.9,25.2-42.6,25.2H167.2L221.8,18z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellLogo);
export default __webpack_public_path__ + "static/media/bell_logo.3cc27f8a566546a0c38b477c88e817eb.svg";
export { ForwardRef as ReactComponent };